import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { SettingsFieldsProps } from './types';

const AuthorizationCodeFields: React.FC<SettingsFieldsProps> = ({
  s,
  se,
  handleChange,
}) => (
  <>
    <Grid item xs={12}>
      <TextField
        fullWidth
        name="settings.clientId"
        value={s.clientId ?? ''}
        onChange={handleChange}
        error={!!se.clientId}
        helperText={se.clientId}
        label="Client ID"
        variant="outlined"
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        fullWidth
        name="settings.clientSecret"
        value={s.clientSecret ?? ''}
        onChange={handleChange}
        error={!!se.clientSecret}
        helperText={se.clientSecret}
        label="Client Secret"
        variant="outlined"
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        fullWidth
        name="settings.scope"
        value={s.scope ?? ''}
        onChange={handleChange}
        error={!!se.scope}
        helperText={se.scope}
        label="Scope"
        variant="outlined"
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        fullWidth
        name="settings.authUri"
        value={s.authUri ?? ''}
        onChange={handleChange}
        error={!!se.authUri}
        helperText={se.authUri}
        label="Auth URI"
        variant="outlined"
      />
    </Grid>
  </>
);

export default AuthorizationCodeFields;
